/* unplugin-vue-components disabled */import { render } from "./pulse.vue?vue&type=template&id=33a5654f&scoped=true"
import script from "./pulse.vue?vue&type=script&lang=js"
export * from "./pulse.vue?vue&type=script&lang=js"

import "./pulse.vue?vue&type=style&index=0&id=33a5654f&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33a5654f"],['__file',"src/pages/pulse/pulse.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "33a5654f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('33a5654f', __exports__)) {
    api.reload('33a5654f', __exports__)
  }
  
  module.hot.accept("./pulse.vue?vue&type=template&id=33a5654f&scoped=true", () => {
    api.rerender('33a5654f', render)
  })

}


export default __exports__